<div class="year-pills">
    <button
        *ngFor="let pill of pills; trackBy: trackByKey"
        type="button"
        class="year-pill"
        [class.year-pill--active]="pill.isSelected"
        [class.year-pill--disabled]="pill.isDisabled"
        [disabled]="pill.isDisabled"
        role="checkbox"
        [attr.aria-checked]="pill.isSelected"
        [attr.aria-disabled]="pill.isDisabled"
        [attr.aria-label]="('aumico_analytics_a11y_year_pill_toggle' | i18next: { year: pill.display })"
        (click)="onClick(pill)">
        <span *ngIf="pill.isSelected" class="year-pill__dot" aria-hidden="true"></span>
        {{ pill.display }}
    </button>
</div>
